import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export function SprintDetailsSkeleton() {
  return (
    <div className="w-full px-4 sm:px-6 lg:px-8 py-6">
      {/* Header Section */}
      <div className="flex items-start justify-between gap-4 mb-6">
        <div className="space-y-2">
          {/* Back button */}
          <Skeleton className="h-8 w-32 mb-2" />
          {/* Title */}
          <Skeleton className="h-8 w-64" />
          {/* Description */}
          <Skeleton className="h-4 w-96" />
        </div>
        <div className="flex gap-2">
          {/* Action buttons */}
          <Skeleton className="h-10 w-32" />
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-24" />
        </div>
      </div>

      {/* Sprint Info Bar */}
      <div className="flex items-center gap-4 mb-6 p-4 bg-muted/30 rounded-lg">
        <Skeleton className="h-6 w-20" />
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-6 w-32" />
      </div>

      {/* Metrics Cards - 4 columns */}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4 mb-6">
        {[1, 2, 3, 4].map(i => (
          <Card key={i}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-4 rounded" />
            </CardHeader>
            <CardContent>
              <Skeleton className="h-8 w-16 mb-1" />
              <Skeleton className="h-3 w-32" />
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Progress Chart and Team Velocity - 2 column grid */}
      <div className="grid gap-6 md:grid-cols-2 mb-6">
        {/* Sprint Progress Chart */}
        <Card>
          <CardHeader>
            <Skeleton className="h-6 w-32 mb-2" />
            <Skeleton className="h-4 w-48" />
          </CardHeader>
          <CardContent>
            <Skeleton className="h-64 w-full" />
          </CardContent>
        </Card>

        {/* Team Velocity */}
        <Card>
          <CardHeader>
            <Skeleton className="h-6 w-32 mb-2" />
            <Skeleton className="h-4 w-48" />
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-2 w-full rounded-full" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-2 w-full rounded-full" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-2 w-full rounded-full" />
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Sprint Tasks Section */}
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <Skeleton className="h-6 w-32 mb-2" />
              <Skeleton className="h-4 w-64" />
            </div>
            <Skeleton className="h-10 w-40" />
          </div>
        </CardHeader>
        <CardContent>
          {/* Task List Items */}
          <div className="divide-y divide-border">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex items-center gap-3 px-4 py-3">
                {/* Icon */}
                <Skeleton className="h-9 w-9 rounded-full flex-shrink-0" />
                
                <div className="flex-1 min-w-0 space-y-2">
                  {/* Title */}
                  <Skeleton className="h-4 w-3/4" />
                  {/* Badges */}
                  <div className="flex items-center gap-2">
                    <Skeleton className="h-5 w-16 rounded-full" />
                    <Skeleton className="h-5 w-20 rounded-full" />
                    <Skeleton className="h-5 w-24 rounded-full" />
                  </div>
                </div>
                
                {/* Story Points Badge */}
                <Skeleton className="h-8 w-8 rounded-full flex-shrink-0" />
                
                {/* Actions Button */}
                <Skeleton className="h-9 w-9 rounded flex-shrink-0" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
